import { generateSeoProps } from '../generateSeoProps';

export const getPublicCertificateSeoProps = ({ name = '', title = '', slug = '', description = '', id = '' }) => {
	return generateSeoProps({
		title: name && title ? `${name} | ${title} | Pharmuni` : 'Pharmuni | Course Certificate',
		description: description || (name && title ? `${name} completed ${title} and earned a Pharmuni certificate.` : 'View course certificate on Pharmuni'),
		canonical: slug ? `public-certificates/${id}/${slug}` : 'public-certificates',
		noIndex: false,
	});
};
